var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSurvey(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 76.043,
    height: 69.706,
    viewBox: "0 0 76.043 69.706",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .class-fill {\r\n        fill: #fff;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "survey_1_",
    "data-name": "survey (1)",
    transform: "translate(0 -21.333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5919",
    "data-name": "Group 5919",
    transform: "translate(0 21.333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5918",
    "data-name": "Group 5918",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12671",
    "data-name": "Path 12671",
    className: "class-fill",
    d: "M108.25,216.5H143.1a1.584,1.584,0,1,0,0-3.169H108.25a1.584,1.584,0,1,0,0,3.169Z",
    transform: "translate(-90.824 -184.817)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12672",
    "data-name": "Path 12672",
    className: "class-fill",
    d: "M127.261,341.333H108.25a1.584,1.584,0,0,0,0,3.169h19.011a1.584,1.584,0,0,0,0-3.169Z",
    transform: "translate(-90.824 -293.806)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12673",
    "data-name": "Path 12673",
    className: "class-fill",
    d: "M69.978,40.344c-.092,0-.181.023-.272.027V27.67a6.344,6.344,0,0,0-6.337-6.337H6.337A6.344,6.344,0,0,0,0,27.67V84.7a6.344,6.344,0,0,0,6.337,6.337H63.369A6.344,6.344,0,0,0,69.706,84.7V55.257l4.561-4.56h0a6.064,6.064,0,0,0-4.289-10.352ZM20.595,27.67a1.584,1.584,0,1,1-1.584,1.584A1.584,1.584,0,0,1,20.595,27.67Zm-6.337,0a1.584,1.584,0,1,1-1.584,1.584A1.584,1.584,0,0,1,14.258,27.67Zm-6.337,0a1.584,1.584,0,1,1-1.584,1.584A1.584,1.584,0,0,1,7.921,27.67ZM63.369,84.7H6.337V37.175H63.369V44.44L48.452,59.354H17.426a1.584,1.584,0,0,0,0,3.169H45.911l-1.521,7.61a1.584,1.584,0,0,0,1.553,1.9A1.618,1.618,0,0,0,46.252,72l7.918-1.584a1.574,1.574,0,0,0,.811-.433l8.388-8.387Zm4.1-31.685-4.1-4.1,2.24-2.24,4.1,4.1Z",
    transform: "translate(0 -21.333)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurvey);
export default __webpack_public_path__ + "static/media/Survey.db71bf357e2e469a76684c218db691d4.svg";
export { ForwardRef as ReactComponent };